module.exports = __webpack_public_path__ + "static/media/isq - copia.a301ee65.svg";